import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Layout from './components/Layout';
import HomePage from './components/HomePage';
import DashboardPage from './pages/DashboardPage';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import CRMPage from './pages/CRMPage';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import ProjectManagementPage from './pages/ProjectManagementPage';
import ProviderDetailsPage from './pages/ProviderDetailsPage';
import { useAuth } from './hooks/useAuth';
import 'mapbox-gl/dist/mapbox-gl.css';
import Construction from './pages/Construction';
import Renovation from './pages/Renovation';
import Design from './pages/Design';
import DocumentCreator from './components/DocumentCreator';
import EstimateForm from './components/EstimateForm';
import Chat from './components/Chat';
import ToolsPage from './pages/ToolsPage';

// Inicializar Stripe con la clave pública del .env
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_live_51PdFv02LyFplWimfCFkfbtMMLwCZLU9UqqaI4QPI1eMZ5Yx6w2vuXmTOEPkZud6lQ4bOlOK28YSU9QoNAonTer9J00Jxi5P8Zj');

const App = () => {
  const { currentUser } = useAuth();

  const checkAccess = (requiredRole) => {
    if (currentUser && currentUser.role === requiredRole) {
      return true;
    }
    return false;
  };

  return (
    <Router>
      <Layout>
        <Elements stripe={stripePromise}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/construccion" element={<Construction />} />
            <Route path="/services/renovacion" element={<Renovation />} />
            <Route path="/services/diseno" element={<Design />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route 
              path="/dashboard" 
              element={currentUser ? <DashboardPage /> : <Navigate to="/signin" />} 
            />
            <Route 
              path="/crm" 
              element={checkAccess('admin') ? <CRMPage /> : <Navigate to="/" />} 
            />
            <Route 
              path="/projects" 
              element={checkAccess('provider') ? <ProjectManagementPage /> : <Navigate to="/" />} 
            />
            <Route path="/providers/:id" element={<ProviderDetailsPage />} />
            <Route path="/documents" element={<DocumentCreator />} />
            <Route path="/estimates" element={<EstimateForm />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/tools" element={<ToolsPage />} />
          </Routes>
        </Elements>
      </Layout>
    </Router>
  );
};

export default App;
